import SharedFlightPassengers from './SharedFlightPassengers';
export default SharedFlightPassengers;
